<!--
 * @Description: 工作任务 日常工作 添加
 * @Author: WangLiXin
 * @Date: 2023-03-28 19:03:21.325
 * @LastEditors: PF
 * @LastEditTime: 2023-12-26 10:39:29
-->
<template>
  <div>
    <el-dialog class="w800 hp80" :model-value="openAddRiChang" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">添加日常工作</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAddRiChang', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="工作类别" prop="gzlbid">
              <el-select v-model="ruleForm.gzlbid" clearable filterable @change="initRiChangGongZuo">
                <el-option v-for="item in gzlbData" :key="item.id" :label="item.gzlbmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="日常工作" prop="rcgzid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.rcgzid" clearable filterable @change="rcgzChange">
                <el-option v-for="item in rcgzData" :key="item.id" :label="item.gzrwbt" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="工作任务标题" prop="gzrwbt" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.gzrwbt" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="待办内容" prop="dbnr" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.dbnr" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="工作时间" prop="kssj" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <div style="display: flex; align-items: center; width: 100%;">
                <el-date-picker class="mr5" type="datetime" v-model="ruleForm.kssj" placeholder="开始时间" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" />
                至
                <el-date-picker class="ml5" type="datetime" v-model="ruleForm.wcsj" placeholder="完成时间" @change="shiFouAnShiWanCheng" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="工作总结" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <ueditor v-model:value="ruleForm.gzzj" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openAddRiChang', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { submitForm, closeWindow, loadSelect, actionPost } from '@/api/common.js'
import { getDate } from '@/utils/index.js'
import ueditor from '@/components/ueditor.vue'

const props = defineProps({ openAddRiChang: { type: Boolean, required: true } })
const emits = defineEmits(['update:openAddRiChang', 'ReturnData'])

const ruleFormRef = ref(null)
const ruleForm = ref({})

const rcgzData = ref()
const initRiChangGongZuo = () => {
  actionPost({ url: '/api/v2/bangong/gongzuoneirong/currentuserbumenrichanggongzuo', data: { order: 'gzrwbt', sort: 'desc', gzlbid: ruleForm.value.gzlbid } }).then((res) => {
    if (res.code === 200) {
      rcgzData.value = res.data
    } else {
      warningPrompt(res.message)
    }
  })
}
const rcgzChange = (val) => {
  rcgzData.value.map((item) => {
    if (item.id === val) {
      ruleForm.value.gzrwbt = item.gzrwbt
      ruleForm.value.gzzj = item.gzms
      ruleForm.value.gznr = item.gzms
      ruleForm.value.dbnr = item.gzms
    }
    return item
  })
}

// 比较两个日期大小。格式：2018-8-12 12:30
const sfaswc = ref(true)
const compareDate2 = (d1, d2) => {
  const date1 = new Date(Date.parse(d1))
  const date2 = new Date(Date.parse(d2))
  return date1 > date2
}
// 是否按时完成
const shiFouAnShiWanCheng = () => {
  if (compareDate2(ruleForm.value.wcsj, ruleForm.value.kssj)) {
    sfaswc.value = false
  } else {
    sfaswc.value = true
  }
}
const gzlbData = ref([]) // 工作类别
watch(
  () => props.openAddRiChang,
  () => {
    if (props.openAddRiChang) {
      
      loadSelect({ url: '/api/v2/bangong/gongzuoleibie/list', data: gzlbData, order: 'gzlbmc', sort: 'asc' })
      initRiChangGongZuo()
      ruleForm.value.kssj = getDate('YYYY', 'MM', 'DD') + ' 09:00'
      ruleForm.value.wcsj = getDate('YYYY', 'MM', 'DD') + ' 18:00'
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  ruleForm.value.dbgzid = ruleForm.value.rcgzid
  //  
  //  return
  submitForm({
    url: '/api/v2/bangong/bangongdaibanshixiang/insertgerenrichanggongzuo',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openAddRiChang', emits, true)
    }
  })
}
</script>
